import React, { useState } from 'react';
import { Trophy } from 'lucide-react';
import * as authApi from '../api/auth';

function LoginPage({ onAuthSuccess, onSwitchToRegister, onForgotPassword }) {
  const [loginForm, setLoginForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const data = await authApi.login({
        email: loginForm.email,
        password: loginForm.password
      });
      onAuthSuccess(data.player || data);
    } catch (error) {
      if (error.name === 'ApiError') {
        setError(error.body?.message || 'Login failed. Please check your credentials.');
      } else {
        console.error('Login error:', error);
        setError('An error occurred during login. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-container fade-in">
      <div className="auth-card">
        <Trophy className="auth-icon" />
        <h1>Welcome Back</h1>
        <p className="auth-subtitle">Log in to access your games</p>

        {error && <div className="error-message">{error}</div>}

        <form onSubmit={handleLogin} className="auth-form">
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              id="email"
              type="email"
              placeholder="Enter your email"
              value={loginForm.email}
              onChange={(e) => setLoginForm({ ...loginForm, email: e.target.value })}
              required
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              id="password"
              type="password"
              placeholder="Enter your password"
              value={loginForm.password}
              onChange={(e) => setLoginForm({ ...loginForm, password: e.target.value })}
              required
              disabled={loading}
            />
          </div>

          <button
            type="submit"
            className="primary-btn full-width"
            disabled={loading}
          >
            {loading ? 'Logging in...' : 'Log In'}
          </button>

          {/*
            * There was no way to do this from the portal at all until the mail path was
            * real - the working recovery was an admin generating a link by hand, because
            * a "forgot password" button that sends nothing is worse than none.
            */}
          <p className="auth-switch">
            <button type="button" onClick={onForgotPassword}>
              Forgotten your password?
            </button>
          </p>

          <p className="auth-switch">
            Don't have an account?{' '}
            <button type="button" onClick={onSwitchToRegister}>
              Register here
            </button>
          </p>
        </form>
      </div>
    </div>
  );
}

export default LoginPage;
